module.exports = __webpack_public_path__ + "img/leeres_Glas.0d74222d.svg";